/** @griffel:css-start [d] null **/
.ftrb29c{list-style-type:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1jat206{-webkit-padding-start:0;padding-inline-start:0;}
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.f778t4r{row-gap:var(--spacingVerticalXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f9b8bpc{padding-block:var(--spacingVerticalS);}
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1dmdbja{background-color:var(--colorNeutralBackground2);}
.fni485r{flex-wrap:wrap;}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.f1j0q4x9{row-gap:var(--spacingVerticalXXS);}
.fuzgk9b{min-inline-size:0;}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.fjksvth{overflow-wrap:anywhere;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkfq4zb{color:var(--colorNeutralForeground2);}
.fy9rknc{font-size:var(--fontSizeBase200);}
.fwrc4pm{line-height:var(--lineHeightBase200);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f11d4kpn{color:var(--colorNeutralForeground3);}
/** @griffel:css-end **/